import { ObjectFactory } from '@/config/objectFactory';
import { Patient } from '@/types/entity';
import { AddPatientRequest, ApiRequest, QueryRecordsRequest } from '@/types/request';
import { ApiResponse, PatientInfo } from '@/types/response';
import { CommonUtils } from '@/util/commonUtils';
import { MedTransGoConstants } from '@/util/constants';
import { IPatientService } from '../iPatientService';
import { Condition } from '@/types/queryRequest';

export class PatientService implements IPatientService {

    public async getPatientList(baseURL: string, searchString?: string, start?: number,
                                limit?: number, locations?: string[]):
    Promise<ApiResponse<PatientInfo[]>> {
        const iHttpService = ObjectFactory.getHttpService();
        const queryRecordsRequest: QueryRecordsRequest = {
            conditions: [
                {
                    fieldName: 'status',
                    op: 'eq',
                    value: 'ACTIVE',
                },
            ],
            limit: limit ? limit : MedTransGoConstants.PAGINATION_LIMIT,
            order: {
                fullName: 1,
            },
            start,
        };
        if (locations && locations.length && queryRecordsRequest.conditions) {
            const condition: Condition = {
                    fieldName: 'location',
                    op: 'in',
                    value: locations,
            };
            queryRecordsRequest.conditions.push(condition);
        }
        const apiRequest: ApiRequest = {
            baseURL,
            data: queryRecordsRequest,
            url: `${MedTransGoConstants.HTTP_URL_PATIENTS}/list`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<PatientInfo[]>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }

    public async getPatientDetails(baseURL: string, patientId: string):
    Promise<ApiResponse<Patient>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_PATIENTS}/${patientId}`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.get<Patient>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }

    public async deletePatient(baseURL: string, patientId: string):
    Promise<ApiResponse<any>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_PATIENTS}/${patientId}`,
        };
        const response = await iHttpService.delete<any>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }

    public async updatePatient(baseURL: string, patientId: string, patientUpdateRequest: Patient):
    Promise<ApiResponse<any>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_PATIENTS}/${patientId}`,
            data: patientUpdateRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<Patient>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }

    public async addPatient(baseURL: string, addPatientRequest: AddPatientRequest):
    Promise<ApiResponse<any>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_ADD_PATIENT}`,
            data: addPatientRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<AddPatientRequest>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }

}
